import { useNavigate } from "react-router-dom";
import { Construction, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

interface ComingSoonPageProps {
  title: string;
  description?: string;
}

/**
 * Empty state for routes whose underlying feature has been intentionally
 * hidden from navigation but remains addressable (e.g. via direct URL or
 * legacy redirects). Communicates that the feature isn't implemented yet
 * and gives the user a way back to Settings.
 */
export default function ComingSoonPage({
  title,
  description = "This feature isn't available yet. We're still building it — check back soon.",
}: ComingSoonPageProps) {
  const navigate = useNavigate();

  return (
    <div className="px-6 py-6 space-y-6">
      <Card className="border-dashed">
        <CardContent className="flex flex-col items-center justify-center text-center py-16 px-6 space-y-4">
          <div className="rounded-full bg-muted p-4">
            <Construction className="h-8 w-8 text-muted-foreground" aria-hidden="true" />
          </div>
          <div className="space-y-2 max-w-md">
            <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
            <p className="text-sm text-muted-foreground">{description}</p>
          </div>
          <Button variant="outline" onClick={() => navigate("/settings")}>
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Settings
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
